import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { FaWhatsapp, FaEye, FaEyeSlash } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Layout from "../../../components/Layouts/Layouts/Layout";
import { country_list } from "../../auth/Register/AllRegiPageLists";
import toast from "react-hot-toast";
import axios from "axios";
import { getURLbyEndPoint } from "../../../store/api";
import { useParams } from "react-router-dom";

const EventBooking = () => {
  const { eventId } = useParams();
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    fullName: "",
    gender: "",
    professionalCategory: "",
    professionalCategoryOther: "",
    professionalDesignation: "",
    professionalDesignationOther: "",
    organizationName: "",
    email: "",
    mobileNumber: "",
    city: "",
    country: "",
    source: [],
    sourceOther: "",
    receiveUpdates: "",
    declarationCorrect: false,
    declarationCertificate: false,
    password: "",
    confirmPassword: "",
    idProof: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const [calculatedFee, setCalculatedFee] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const designationLists = {
    "Advocate / Lawyer": [
      "Counsel",
      "Senior Advocate",
      "Junior Advocate",
      "Partner",
      "Associate",
      "Other",
    ],
    Arbitrator: ["Arbitrator", "Panel Arbitrator", "Member", "Other"],
    "In-house Counsel": [
      "Legal Manager",
      "General Counsel",
      "Legal Associate",
      "Other",
    ],
    "Chartered Accountant": ["Partner", "Associate", "Other"],
    "Company Secretary": ["Company Secretary", "Assistant CS", "Other"],
    "Law Student": [
      "1st Year",
      "2nd Year",
      "3rd Year",
      "4th Year",
      "5th Year",
      "LLM Student",
      "Other",
    ],
    Academician: ["Professor", "Assistant Professor", "Dean", "Other"],
    "Business Professional": ["Director", "CEO", "Manager", "Other"],
    "Legal Professional": ["Paralegal", "Legal Assistant", "Other"],
    Other: ["Other"],
  };

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        let targetEventId = eventId;
        if (!targetEventId) {
          const allEventsResponse = await axios.get(
            getURLbyEndPoint("getAllEvents"),
          );
          if (allEventsResponse.data && allEventsResponse.data.length > 0) {
            // Find the latest event that is not closed
            const openEvent = allEventsResponse.data.find(
              (e) => !e.isRegistrationClosed,
            );
            if (openEvent) {
              targetEventId = openEvent._id;
            } else {
              setLoading(false);
              return; // We will show "Event Not Found" or "No events available" since targetEventId is empty and no event is loaded
            }
          } else {
            setLoading(false);
            return;
          }
        }

        const response = await axios.get(
          getURLbyEndPoint("getEventById") + targetEventId,
        );
        if (response.data.status) {
          setEventData(response.data.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvent();
  }, [eventId]);

  useEffect(() => {
    if (eventData) {
      setCalculatedFee(eventData.fee || 0);
    }
  }, [eventData]);

  const [validated, setValidated] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") {
      if (name === "source") {
        let newSource = [...formData.source];
        if (checked) {
          newSource.push(value);
        } else {
          newSource = newSource.filter((item) => item !== value);
        }
        setFormData({ ...formData, source: newSource });
      } else if (
        name === "declarationCorrect" ||
        name === "declarationCertificate"
      ) {
        setFormData({ ...formData, [name]: checked });
      }
    } else if (type === "file") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      // Reset designation if category changes
      if (name === "professionalCategory") {
        setFormData({
          ...formData,
          [name]: value,
          professionalDesignation: "",
          professionalDesignationOther: "",
        });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    }

    // Clear error for the field being changed
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleSubmit = async (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    const newErrors = {};

    // Validate standard fields using form validity
    if (form.checkValidity() === false) {
      setValidated(true);
    }

    // Custom validations
    if (!formData.fullName) newErrors.fullName = "Full Name is required.";
    if (!formData.gender) newErrors.gender = "Please select your gender.";
    if (!formData.professionalCategory) {
      newErrors.professionalCategory = "Professional Category is required.";
    } else if (formData.professionalCategory === "Other" && !formData.professionalCategoryOther?.trim()) {
      newErrors.professionalCategoryOther = "Specify Category is required.";
    }
    
    if (!formData.professionalDesignation) {
      newErrors.professionalDesignation = "Designation is required.";
    } else if ((formData.professionalDesignation === "Other" || formData.professionalCategory === "Other") && !formData.professionalDesignationOther?.trim()) {
      newErrors.professionalDesignationOther = "Specify Designation is required.";
    }
    if (!formData.email) newErrors.email = "Valid email is required.";
    if (!formData.mobileNumber)
      newErrors.mobileNumber = "Mobile Number is required.";
    if (!formData.city) newErrors.city = "City is required.";
    if (!formData.country) newErrors.country = "Country is required.";
    if (formData.source.length === 0)
      newErrors.source = "Please select how you heard about us.";
    if (!formData.declarationCorrect)
      newErrors.declarationCorrect = "Please accept the declaration.";
    if (!formData.declarationCertificate)
      newErrors.declarationCertificate = "Please accept the certificate terms.";
    if (!formData.idProof) newErrors.idProof = "Please upload your ID Proof.";

    if (!formData.password) {
      newErrors.password = "Password is required.";
    }
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match!";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setValidated(true);
      // Scroll to the first error
      const firstError = Object.keys(newErrors)[0];
      const element = document.getElementsByName(firstError)[0];
      if (element)
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setIsSubmitting(true);
    try {
      // Prepare Payload
      const apiFormData = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === "source") {
          formData.source.forEach((s) => apiFormData.append("source[]", s));
        } else if (key === "idProof" && formData.idProof) {
          apiFormData.append("idProof", formData.idProof);
        } else if (key !== "confirmPassword") {
          apiFormData.append(key, formData[key]);
        }
      });
      apiFormData.append("eventId", eventData?._id);
      apiFormData.append("totalFee", calculatedFee);

      const response = await axios.post(
        getURLbyEndPoint("createEventBooking"),
        apiFormData,
      );

      if (response.data.status) {
        toast.success("Registration Successful!");
        setIsSubmitted(true);
        window.scrollTo(0, 0);
      } else {
        toast.error(
          response.data.message || "Something went wrong. Please try again.",
        );
      }
    } catch (error) {
      console.error(error);
      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(errorMsg);
    } finally {
      setIsSubmitting(false);
    }

    setValidated(true);
  };

  const professionalCategories = [
    "Advocate / Lawyer",
    "Arbitrator",
    "In-house Counsel",
    "Chartered Accountant",
    "Company Secretary",
    "Law Student",
    "Academician",
    "Business Professional",
    "Legal Professional",
    "Other",
  ];

  const sources = [
    "Website",
    "Social Media",
    "Email Invitation",
    "WhatsApp",
    "Reference",
    "Other",
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${minutes} ${ampm} IST`;
  };

  if (loading) {
    return (
      <Layout>
        <div className="text-center my-5">Loading event details...</div>
      </Layout>
    );
  }

  if (!eventData) {
    return (
      <Layout>
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ minHeight: "80vh", padding: "20px" }}
        >
          <h2 className="fw-bold text-dark" style={{ fontSize: "2.5rem" }}>
            Event Not Available
          </h2>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="custom-width mx-auto my-4">
        <Row className="mt-2">
          <Col sm={12} lg={6} className="mb-4">
            <div className="fw-bold fs-3" style={{ color: "#021C43" }}>
              {eventData.eventType} on - {eventData.title}
            </div>

            <h5 className="mt-3">Speaker: {eventData.speaker}</h5>
            <p>
              <strong>Date:</strong> {formatDate(eventData.eventDate)} (
              {new Date(eventData.eventDate).toLocaleDateString("en-US", {
                weekday: "long",
              })}
              )
              <br />
              <strong>Time:</strong> {formatTime(eventData.eventTime)}
              {eventData.timeTo && ` – ${formatTime(eventData.timeTo)}`}
              <br />
              <strong>Mode:</strong> {eventData.location}
            </p>

            <p>
              <strong>Registration Fee:</strong>{" "}
              {calculatedFee > 0 ? (
                <span className="fw-bold text-primary">
                  {calculatedFee}/- Per Participant
                </span>
              ) : (
                <>
                  {eventData.actualPrice > 0 && (
                    <span
                      className="text-danger me-2"
                      style={{ textDecoration: "line-through" }}
                    >
                      {eventData.actualPrice}/- Per Participant
                    </span>
                  )}
                  <span className="fw-bold text-success">
                    Free of Charge (Registration Mandatory)
                  </span>
                </>
              )}
            </p>

            {eventData.eCertificate && (
              <p>
                <strong>Feature:</strong> E-Certificate of Participation
              </p>
            )}

            <div className="mt-4">
              <p>
                <strong>
                  AECCI – International Arbitration Centre (AECCI-IAC)
                </strong>
                <br />
                (An Initiative by the Asian Exporters' Chamber of Commerce &
                Industry- A chamber recognised by the Ministry of Commerce &
                Industry, Government of India)
              </p>

              <p>
                Invites you to a '{eventData.eventType}' on
                <br />
                <strong>'{eventData.title}'</strong>
                <br />(
                {eventData.location === "Online"
                  ? "Digital Session"
                  : "In-Person Session"}
                )
              </p>

              <p>{eventData.description}</p>
              <p className="text-danger fw-bold">
                Seats are limited. Early registration is encouraged.
              </p>
            </div>

            <hr />
            <h5 className="fw-semibold mt-4">Contact us for more details:</h5>
            <Row className="mt-3">
              <Col md={12} xs={12}>
                <div className="d-flex align-items-start gap-2 my-2">
                  <div>
                    <strong>AECCI Legal Wing</strong>
                  </div>
                </div>
                <div className="d-flex align-items-start gap-2 my-2">
                  <FaWhatsapp size={20} />
                  <div className="fw-semibold">
                    WhatsApp:{" "}
                    <a
                      href="https://wa.me/918433720996"
                      className="text-decoration-none"
                    >
                      +91-8433720996
                    </a>
                  </div>
                </div>
                <div className="d-flex align-items-start gap-2 my-2">
                  <MdEmail size={20} />
                  <div className="fw-semibold">
                    Email:{" "}
                    <a
                      href="mailto:legal@aecci.org.in"
                      className="text-decoration-none"
                    >
                      legal@aecci.org.in
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>

          <Col sm={12} lg={6}>
            {eventData.isRegistrationClosed ? (
              <div
                className="d-flex flex-column align-items-center justify-content-center h-100 p-4"
                style={{
                  backgroundColor: "#021C43",
                  color: "white",
                  borderRadius: "8px",
                }}
              >
                <h3 className="fw-bold mb-3">Registration Closed</h3>
                <p className="text-center">
                  Registration for this event is now closed. Stay tuned for our
                  upcoming programs or contact us for more information.
                </p>
                <a href="/" className="btn btn-warning mt-3 fw-bold px-4">
                  Return to Home
                </a>
              </div>
            ) : !isSubmitted ? (
              <div
                className="text-white montserratFont"
                style={{ background: "#021C43", padding: "20px" }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="text-white mb-0">
                    PARTICIPANT REGISTRATION FORM
                  </h4>
                  <a
                    href="https://e-platform.aecci.org.in/login"
                    className="btn btn-sm btn-outline-warning rounded-pill px-3"
                    style={{ fontSize: "12px", fontWeight: "600" }}
                  >
                    Already registered? Login
                  </a>
                </div>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  {/* 1. Personal Details */}
                  <h5 className="text-warning mb-3">1. Personal Details</h5>

                  <Row>
                    <Col md={8}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Full Name (as on certificate) *
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleInputChange}
                          required
                          maxLength={50}
                          className="rounded-0"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.fullName || "Name required."}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Gender *</Form.Label>
                        <Form.Select
                          size="sm"
                          name="gender"
                          value={formData.gender}
                          onChange={handleInputChange}
                          required
                          className="rounded-0"
                        >
                          <option value="">Select</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Prefer not to say">
                            Prefer not to say
                          </option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.gender || "Required."}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Professional Category *
                        </Form.Label>
                        <Form.Select
                          size="sm"
                          name="professionalCategory"
                          value={formData.professionalCategory}
                          onChange={handleInputChange}
                          required
                          className="rounded-0"
                        >
                          <option value="">Select Category</option>
                          {professionalCategories.map((cat, idx) => (
                            <option key={idx} value={cat}>
                              {cat}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.professionalCategory || "Required."}
                        </Form.Control.Feedback>
                        {formData.professionalCategory === "Other" && (
                          <>
                            <Form.Control
                              size="sm"
                              type="text"
                              placeholder="Specify Category"
                              name="professionalCategoryOther"
                              value={formData.professionalCategoryOther}
                              onChange={handleInputChange}
                              className="mt-2 rounded-0"
                              isInvalid={!!errors.professionalCategoryOther}
                            />
                            {errors.professionalCategoryOther && (
                              <div className="text-danger small mt-1">
                                {errors.professionalCategoryOther}
                              </div>
                            )}
                          </>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Designation *
                        </Form.Label>
                        <Form.Select
                          size="sm"
                          name="professionalDesignation"
                          value={formData.professionalDesignation}
                          onChange={handleInputChange}
                          required
                          className="rounded-0"
                          disabled={!formData.professionalCategory}
                        >
                          <option value="">Select Designation</option>
                          {formData.professionalCategory &&
                            designationLists[
                              formData.professionalCategory
                            ]?.map((des, i) => (
                              <option key={i} value={des}>
                                {des}
                              </option>
                            ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.professionalDesignation || "Required."}
                        </Form.Control.Feedback>
                        {(formData.professionalDesignation === "Other" ||
                          formData.professionalCategory === "Other") && (
                          <>
                            <Form.Control
                              size="sm"
                              type="text"
                              placeholder="Specify Designation"
                              name="professionalDesignationOther"
                              value={formData.professionalDesignationOther}
                              onChange={handleInputChange}
                              className="mt-2 rounded-0"
                              isInvalid={!!errors.professionalDesignationOther}
                            />
                            {errors.professionalDesignationOther && (
                              <div className="text-danger small mt-1">
                                {errors.professionalDesignationOther}
                              </div>
                            )}
                          </>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Organization / Institution Name (Optional)
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="organizationName"
                          value={formData.organizationName}
                          onChange={handleInputChange}
                          className="rounded-0"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Professional ID Proof *
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          type="file"
                          name="idProof"
                          onChange={handleInputChange}
                          required
                          className="rounded-0"
                        />
                        <Form.Text className="text-light small">
                          (Upload ID Card / Certificate)
                        </Form.Text>
                        {errors.idProof && (
                          <div className="text-danger small mt-1">
                            {errors.idProof}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* 2. Contact Details */}
                  <h5 className="text-warning mt-4 mb-3">2. Contact Details</h5>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Email Address *
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          className="rounded-0"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email || "Valid email required."}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Mobile Number *
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="mobileNumber"
                          value={formData.mobileNumber}
                          onChange={handleInputChange}
                          required
                          className="rounded-0"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.mobileNumber || "Mobile required."}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Create Password *
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            size="sm"
                            type={showPassword ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            required
                            className="rounded-0 pe-5"
                          />
                          <div
                            className="position-absolute end-0 top-50 translate-middle-y me-2 cursor-pointer text-dark"
                            style={{ cursor: "pointer", zIndex: 10 }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </div>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          Password required.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          Confirm Password *
                        </Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            size="sm"
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleInputChange}
                            required
                            className="rounded-0 pe-5"
                          />
                          <div
                            className="position-absolute end-0 top-50 translate-middle-y me-2 cursor-pointer text-dark"
                            style={{ cursor: "pointer", zIndex: 10 }}
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                          >
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                          </div>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          {errors.confirmPassword || "Passwords must match."}
                        </Form.Control.Feedback>
                        {(errors.confirmPassword ||
                          (formData.confirmPassword &&
                            formData.password !==
                              formData.confirmPassword)) && (
                          <div className="text-danger small mt-1">
                            {errors.confirmPassword ||
                              "Passwords do not match!"}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">City *</Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleInputChange}
                          required
                          className="rounded-0"
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.city || "Required."}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Country *</Form.Label>
                        <Form.Select
                          size="sm"
                          name="country"
                          value={formData.country}
                          onChange={handleInputChange}
                          required
                          className="rounded-0"
                        >
                          <option value="">Select Country</option>
                          {country_list.map((c, i) => (
                            <option key={i} value={c}>
                              {c}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.country || "Required."}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* 3. Additional Information */}
                  <h5 className="text-warning mt-4 mb-3">
                    3. Additional Information
                  </h5>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      How did you know about this webinar?
                    </Form.Label>
                    <Row>
                      {sources.map((src, idx) => (
                        <Col xs={6} md={4} key={idx}>
                          <Form.Check
                            type="checkbox"
                            label={src}
                            name="source"
                            value={src}
                            onChange={handleInputChange}
                            id={`src-${idx}`}
                          />
                        </Col>
                      ))}
                    </Row>
                    {errors.source && (
                      <div className="text-danger small mt-1">
                        {errors.source}
                      </div>
                    )}
                    {formData.source.includes("Other") && (
                      <Form.Control
                        size="sm"
                        type="text"
                        placeholder="Please specify"
                        name="sourceOther"
                        value={formData.sourceOther}
                        onChange={handleInputChange}
                        className="mt-2 rounded-0"
                        required
                      />
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      Receive updates about future programs?
                    </Form.Label>
                    <div className="d-flex gap-3">
                      <Form.Check
                        inline
                        type="radio"
                        label="Yes"
                        name="receiveUpdates"
                        value="Yes"
                        onChange={handleInputChange}
                        required
                      />
                      <Form.Check
                        inline
                        type="radio"
                        label="No"
                        name="receiveUpdates"
                        value="No"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </Form.Group>

                  {/* 4. Declaration */}
                  <h5 className="text-warning mt-4 mb-3">4. Declaration</h5>

                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="I confirm that the above information is true and correct."
                      name="declarationCorrect"
                      checked={formData.declarationCorrect}
                      onChange={handleInputChange}
                      required
                    />
                    {errors.declarationCorrect && (
                      <div className="text-danger small mt-1">
                        {errors.declarationCorrect}
                      </div>
                    )}
                    <Form.Check
                      className="mt-2"
                      type="checkbox"
                      label="I understand that the e-certificate will be issued only to registered participants who attend the session."
                      name="declarationCertificate"
                      checked={formData.declarationCertificate}
                      onChange={handleInputChange}
                      required
                    />
                    {errors.declarationCertificate && (
                      <div className="text-danger small mt-1">
                        {errors.declarationCertificate}
                      </div>
                    )}
                  </Form.Group>

                  <div className="d-grid mt-4">
                    <Button
                      type="submit"
                      variant="primary"
                      className="rounded-0 fw-bold py-2"
                      size="sm"
                      style={{ backgroundColor: "#0d6efd", border: "none" }}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Processing...
                        </>
                      ) : (
                        "Submit Registration"
                      )}
                    </Button>
                  </div>
                </Form>
              </div>
            ) : (
              <div
                className="card shadow p-4"
                style={{ borderTop: "5px solid #021C43" }}
              >
                <div className="text-center mb-4">
                  <h3 className="text-success fw-bold">
                    Registration Successful!
                  </h3>
                </div>

                <p>
                  Thank you for registering for the session:{" "}
                  <strong>
                    {eventData.eventType} on ‘{eventData.title}’
                  </strong>
                </p>
                <hr />
                <p>
                  <strong>Speaker:</strong> {eventData.speaker}
                  <br />
                  <strong>Date:</strong> {formatDate(eventData.eventDate)} |{" "}
                  <strong>Time:</strong> {formatTime(eventData.eventTime)}
                </p>

                <div className="alert alert-success mt-3">
                  <strong>
                    Your registration has been successfully received.
                  </strong>
                </div>

                <ol className="mt-3">
                  <li>
                    You can login to the AECCI-IAC Event Platform by using the
                    credential- to access the webinar.
                  </li>
                  <li>
                    Your login credentials (Username & Password) have been sent
                    to your registered email address.
                  </li>
                  <li>
                    If not found in your Inbox, please check your Spam/Junk
                    folder.
                  </li>
                </ol>

                <p className="mb-2 mt-3">
                  We recommend logging in at least 5–10 minutes before the
                  session to avoid last-minute technical issues.
                </p>
                <p>
                  <strong>
                    E-Certificate of Participation will be issued through your
                    registered account.
                  </strong>
                </p>

                <hr />
                <p className="text-muted small mb-0">
                  For any assistance, please contact us at{" "}
                  <strong>8433720996</strong> or{" "}
                  <a href="mailto:legal@aecci.org.in">legal@aecci.org.in</a>
                </p>
                <div className="text-center mt-3">
                  <div className="fw-bold">
                    We look forward to your participation.
                  </div>
                  <div className="small text-muted">
                    AECCI – International Arbitration Centre (AECCI-IAC)
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button
                    variant="outline-primary"
                    onClick={() => window.location.reload()}
                  >
                    Book Another
                  </Button>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default EventBooking;
